import React, { useState, useEffect } from 'react';
import { Form, Radio } from 'antd';
import Typing from '../Typing/Typing';
import * as Utils from '../../services/utils';
import CmpsAnimation from '../CmpsAnimation/CmpsAnimation';
import Timestamp from '../../components/Timestamp/Timestamp'
import CmpsMsgStatus from '../CmpsMsgStatus/CmpsMsgStatus';

function CmpsJob({onComplete, onScroll, form, onShowInput}) {
  const [typing, setTyping] = useState(true);
  const [msg, setMsg] = useState(false);

  let list = [
    {label: 'Lavoratore dipendente', value: 2},
    {label: 'Lavoratore autonomo', value: 1},
    {label: 'Pensionato', value: 3},
    {label: 'Altro', value: 4}
  ];

  const onChange = (e) => {
    setMsg(form.getFieldValue("tipo_impiegato").label);
    onComplete('step12');
  }

  useEffect(() => {
    Utils.eventsDataLayer('customPageview', '/chatbot-fissa-appuntamento/impiego');
    onShowInput(false);
    const timer = setTimeout(() => {
      setTyping(false);
      onScroll();
    }, 2200);
    return () => clearTimeout(timer);
  }, []);

  return (
    <section id="cmps-job">
      {typing && <Typing wait={1200} />}
      {!typing && (
        <div className="messages messages--receiver">
          <div className="message">
            <CmpsAnimation wait={300} last={true}>
              <span className="bubble">Che tipologia di impiego hai?</span>
            </CmpsAnimation>
            <CmpsAnimation wait={600}>
              {!msg && (
                <Form.Item className={`cmps_radio_button`} name="tipo_impiegato">
                  <Radio.Group onChange={onChange}>
                    {list.map((item, index) =>
                      <Radio.Button key={index} value={item}>
                        {item.label}
                      </Radio.Button>
                    )}
                  </Radio.Group>
                </Form.Item>
              )}
              <div className="info">
                <span className="time"><Timestamp /></span>
              </div>
            </CmpsAnimation>
          </div>
        </div>
      )}
      {msg && (
        <div className="messages messages--sender">
          <CmpsAnimation wait={300}>
            <div className="message">
              <span className="bubble">{msg}</span>
            </div>
            <div className="info">
              <span className="time"><Timestamp /></span>
              <CmpsMsgStatus />
            </div>
          </CmpsAnimation>
        </div>
      )}
    </section>
  );
  
} 

export default CmpsJob;